/**
 * Errors Sentry should not report – not actionable code bugs.
 * Used to limit quota usage and noise.
 */
export const SENTRY_IGNORE_ERRORS: (string | RegExp)[] = [
  // Benign browser quirk when ResizeObserver fires in a loop during rapid layout changes; not a real bug
  "ResizeObserver loop limit exceeded",
  // Promise rejected with non-Error value (string, etc.) – often lacks stack trace and is low-value
  "Non-Error promise rejection captured",
  // Connection failures, CORS, DNS, offline – environmental, not actionable code bugs
  /^Network Error/,
  // 4xx responses (401, 403, 404) – usually auth/state issues, not application errors
  /^Request failed with status code 4/,
  // User aborted request (e.g. navigated away) – intentional, not a bug
  /^AbortError/,
  /^CanceledError$/,
  /cancelled/i,
  // Generic fetch/load failures – often same root cause as Network Error
  /^Failed to fetch$/,
  /^Load failed$/,
  // Cross-origin script errors – browser strips message for security; unactionable
  "Script error.",
];
